import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default group => {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch({
                type: `NOTIFICATIONS:KILL-GROUP`,
                payload: {
                    group
                }
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
